// Centralized sidebar behaviors (visibility and role-based nav tweaks)
export function applySidebarPermissions(user) {
  const role = String(user?.role || '').toUpperCase();
  const dept = String(user?.departement || '').toUpperCase();

  // ADN: only visible for ADN department/role
  const navADN = document.getElementById('navADN');
  const canSeeADN = role === 'ADN' || dept === 'ADN';
  if (navADN) navADN.style.display = canSeeADN ? 'flex' : 'none';

  // Gestion données + Signup: responsables only
  const navData = document.getElementById('navData');
  const navSignup = document.getElementById('navSignup');
  const canSeeResp = role === 'RESPONSABLE';
  if (navData) navData.style.display = canSeeResp ? 'flex' : 'none';
  if (navSignup) navSignup.style.display = canSeeResp ? 'flex' : 'none';
}
